
import {fetch,promptMessage } from '@/api/dataHandling';
import {urlConfig} from '@/api/urlConfig';
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import {formatDate} from '../../../static/js/date';
export default {
data(){
return{
datereadonly:true,
projectName:'',
date:'',
projectOptions:[],
dateOptions:[],
}
},
components: {
XButton, XHeader,Group, PopupRadio
},
methods:{
getProject(){
this.projectOptions = [];
fetch('get',urlConfig.surgicalAppointGetProject).then(response => {
this.$store.commit('updateLoadingStatus',{isLoading:false});
for(let i =0;i<response.length;i++){
this.projectOptions.push({value:response[i].itemMane,key:response[i].id});
}

}).catch(error => {
});
},

getDate(){
this.dateOptions = [];
fetch('get',urlConfig.surgicalAppointGetDate + '?itemId=' + this.projectName).then(response => {
for(let i =0;i<response.length;i++){
if(response[i].scheduleDate != this.toDate && response[i].scheduleDate != this.twoDate){
this.dateOptions.push({value:response[i].remainNum,key:response[i].scheduleDate});
}

}

}).catch(error => {
});
},
projectChoose(){
this.date = '';
if(this.projectName == ''){
this.datereadonly = true;
}else {
this.datereadonly = false;
this.getDate();
}
},
dateClick(){
if(this.projectName == ''){
this.datereadonly = true;
promptMessage('提示','请先选择手术名称！')
}else {
this.datereadonly = false;
}
},
save(){
this.parmaData = new URLSearchParams();
this.parmaData.append('personInfoId',this.personInfoId);
this.parmaData.append('itemId',this.projectName);
this.parmaData.append('scheduleDate',this.date);
let _this = this;
if(this.projectName != '' && this.date != ''){ //提交
fetch('post',urlConfig.surgicalAppointSave,this.parmaData).then(response => {
promptMessage('提示','保存成功！',function(){
_this.$router.push({path:'/reservationIndex?openid='+_this.$route.query.openid,query:{tabindex:1,personInfoId:_this.personInfoId,type:'ss',}});
});

}).catch(error => {
});
}else {
promptMessage('提示','还有选项未选择！');
}
}
},
mounted(){
let today = new Date().getTime();
let twoDay = new Date().getTime() + 1 * 24 * 3600 * 1000;
this.toDate = formatDate(new Date(today), 'yyyy-MM-dd');
this.twoDate = formatDate(new Date(twoDay), 'yyyy-MM-dd');
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.getProject()
this.personInfoId = this.$route.query.personInfoId;
}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/surgicalAppointmentAdd.vue